// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-search-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 5.08966C12 7.5 9 9.46667 9 9.46667C9 9.46667 6 7.5 6 5.08966C6 3.38329 7.23637 2 9 2C10.75 2 12 3.38329 12 5.08966Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M21 16.25C21 18.3211 19.3211 20 17.25 20C15.1789 20 13.5 18.3211 13.5 16.25C13.5 14.1789 15.1789 12.5 17.25 12.5C19.3211 12.5 21 14.1789 21 16.25Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 5.2002H21V9.50019M6 5.2002H3V19.0002H10M9 14.5002L6 12.6002L3.375 14.0002M12 5.08965C12 7.5 9 9.46667 9 9.46667C9 9.46667 6 7.5 6 5.08965C6 3.38329 7.23638 2 9 2C10.75 2 12 3.38329 12 5.08965Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19.9036 18.8997L21.5 20.5M21 16.25C21 18.3211 19.3211 20 17.25 20C15.1789 20 13.5 18.3211 13.5 16.25C13.5 14.1789 15.1789 12.5 17.25 12.5C19.3211 12.5 21 14.1789 21 16.25Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-search-1')
export default class MapSearch1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-search-1',
    }
  }
}
